// 초를 분으로 변환 ex. ss.s -> mm:ss

export const formatDuration = (seconds) => {
  const mins = Math.floor(seconds / 60);
  const secs = Math.floor(seconds % 60);

  if (mins === 0) return `${secs}초`;
  return `${mins}분 ${secs}초`;
};